import { Component, OnInit } from '@angular/core';
import { CaseService } from '../../../../shared/services/case.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-seven-one-main',
  templateUrl: './seven-one-main.component.html',
  styleUrls: ['./seven-one-main.component.scss']
})
export class SevenOneMainComponent implements OnInit {


  org: string;
  token: string;
  role: string;
  userId: string;
  caseId: string;
  caseData: any;
  spentAmount: any;
  receiveAmount: any;
  caseTransaction: any;
  error: string;

  exsitingTransactions = {
    start_date: '01/01/18',
    end_date: '12/31/18',
    transactions: {
      POSITIVE: [],
      NEGATIVE: []
    }
  }
  getExistingDetails: boolean = false;
  selectedTab = 'receiveAmount';
  constructor(
    public caseService: CaseService,
    private localUser: LocalUserService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,

  ) {
    this.org = this.localUser.getOrganizationId();
    this.token = this.localUser.getToken();
    this.role = this.localUser.getRole();
    this.userId = this.localUser.getUserId();
    this.caseId = this.route.snapshot.params['case'];
  }

  ngOnInit() {
    this.getAllTransaction()
    this.reload()
  }

  getAllTransaction() {
    this.caseService.getCaseTransaction(this.org, this.caseId, '01012018', '12312018')
      .subscribe(result => {
        this.caseTransaction = result
        this.spentAmount = result.POSITIVE
        this.receiveAmount = result.NEGATIVE
      })
  }

  reload() {
    this.caseService.getCaseById(this.org, this.caseId)
      .subscribe(result => {
        this.caseData = result;
      })
  }

  submitSevenOne() {
    this.getExistingDetails = true
    // if (this.exsitingTransactions.transactions.POSITIVE.length > 0 && this.exsitingTransactions.transactions.NEGATIVE.length > 0) {
    this.caseService.postSevenOne(this.org, this.caseId, this.exsitingTransactions)
      .subscribe(result => {
        // const a = document.createElement('a');
        // document.body.appendChild(a);
        // a.href = result.url
        // a.target = '_blank';
        // a.setAttribute('style', 'display: none');
        // a.download = 'test';
        // a.click();
        // document.body.removeChild(a);
        this.router.navigate(['dashboard']);
      }, error => {
        this.error = 'Can not get Form';
        this.snackBar.open(this.error, '', {
          duration: 2000,
        });
        this.getExistingDetails = false
      });
    // }
  }
  receiveDetails(event) {
    this.exsitingTransactions.transactions.POSITIVE = event
    this.submitSevenOne()
  }
  spentDetails(event) {
    this.exsitingTransactions.transactions.NEGATIVE = event
    this.submitSevenOne()
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/seven-one/seven-one-main/seven-one-main.component.ts